import request from '@/utils/request'
const subordinateApi = {
  // 查询下级
  querySubordinateList: (params) => {
    return request({
      url: '/client/sub/query',
      method: 'get',
      params
    })
  },
  // 关闭消费限制（即 可以使用积分消费）
  enablePoint: (data) => {
    return request({
      url: '/client/sub/limit/disable',
      method: 'post',
      data
    })
  },
  // 启用消费限制（即 不可以使用积分消费）
  limitPoint: (data) => {
    return request({
      url: '/client/sub/limit/enable',
      method: 'post',
      data
    })
  },
  // 下级积分转出
  transferOutPoint: (data) => {
    return request({
      url: '/client/sub/point/transfer-out',
      method: 'post',
      data
    })
  },
  // 下级积分转入
  transferInPoint: (data) => {
    return request({
      url: '/client/sub/point/transfer-in',
      method: 'post',
      data
    })
  }
}

export default subordinateApi
